<template>
    <div>
        <div
            class="mb-6"
            v-for="(widget, index) in components"
            :key="index"
            :is="widget.type"
            :data="widget"
            :override-background="true"
        ></div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AddToHomeScreen from "@/components/common/AddToHomeScreen";

export default {
    name: "Page",
    props: ["value"],
    computed: mapGetters({ page: "page/page", components: "page/components" }),
    methods: mapActions({ fetch: "page/fetch" }),
    watch: {
        page() {
            document.title = this.page.name || 'Loading...';
        }
    },
    mounted() {
        this.fetch(this.$route.params.slug);

        window.addEventListener("message", event => {
            if (event.data === "preview_request_refresh") {
                this.fetch(this.$route.params.slug);
            }
        });
    },
    components: {
        AddToHomeScreen
    }
};
</script>
<style>
[data-view-type="page"] .bb-view-background {
    background: var(--page-background);
}

.bb-component-background {
    background: var(--page-component-background-color);
}
.bb-component-heading {
    color: var(--page-component-heading-color);
    font-size: var(--page-component-heading-font-size);
    font-weight: var(--page-component-heading-font-weight);
    line-height: var(--page-component-heading-line-height);
}
.bb-component-subheading {
    color: var(--page-component-subheading-color);
    font-size: var(--page-component-subheading-font-size);
    font-weight: var(--page-component-subheading-font-weight);
    line-height: var(--page-component-subheading-line-height);
}
.bb-component-content {
    white-space: pre-line;
    color: var(--page-component-content-color);
    font-size: var(--page-component-content-font-size);
    font-weight: var(--page-component-content-font-weight);
    line-height: var(--page-component-content-line-height);
}
.bb-component-button {
    color: var(--page-component-button-color);
    background: var(--page-component-button-background-color);
}
</style>
